class BioList extends ESWPPostList {

	constructor() {
		super();
		this.paginationAttachEventListeners();
		this.addUpdateTemplateElementCallback('pagination', this.paginationAttachEventListeners);
	}
	connectedCallback() {
		console.log(this.constructor);
	}
	
	paginationAttachEventListeners = () => {
		const pagerButtonElements = this.templateElements.pagination.querySelectorAll('button');
		for (let buttonElement of pagerButtonElements) {
			buttonElement.addEventListener('click', this.paginationButtonClickHandler);
		}
	}

	paginationButtonClickHandler = async (event) => {
		const page = event.target.getAttribute('data-page');
		await this.appendPage(page);
	}

	getFormValues() {
		return this.constructor.getFormValues(this.templateElements.form);
	}

	async getPage(page) {
		const isArchive = this.templateElements.results.getAttribute('data-is-archive');
		const archivePost = this.templateElements.results.getAttribute('data-archive-id');
		const args = {
			key: this.key,
			templates: ['results', 'pagination'],
			request_data: {'is_archive': isArchive, 'archive_id' : archivePost, 'page': page},
			page: page
		};
		const newTemplates = await this.fetchTemplates(args);
		return newTemplates;
	}

	async goToPage(page) {
		const newTemplates = await this.getPage(page);
		this.updateTemplateElement('results', newTemplates.results);
		this.updateTemplateElement('pagination', newTemplates.pagination);
	}

	async appendPage(page) {
		const newTemplates = await this.getPage(page);
		const resultsContainer = this.querySelector(
			'[data-post-list-template="results"]'
		);
		const htmlObject = document.createElement("div");
		htmlObject.innerHTML = newTemplates.results;
		const newResultsItems = htmlObject.querySelectorAll(
			'[data-post-list-template="results"] > li'
		);
		for (const newResultsItem of newResultsItems) {
			resultsContainer.append(newResultsItem);
		}
		this.updateTemplateElement("pagination", newTemplates.pagination);
	}

}

document.addEventListener('DOMContentLoaded', () => {
	customElements.define('post-list-bio-list', BioList, {extends: 'div'});
});
